"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocsHomepageElementName = exports.DocsProtocolVersion = exports.DocsSectionName = void 0;
/**
 * Sections. Disambiguate low-level elements that may share a name.
 * eg a `back` button in a modal will have the same `element`,
 * but a different `section`.
 */
var DocsSectionName;
(function (DocsSectionName) {
    DocsSectionName["BOTTOM_MENU_LINKS"] = "Bottom Menu Links";
    DocsSectionName["DEVELOPER_LINKS"] = "Developer Links";
    DocsSectionName["GETTING_STARTED_LINKS"] = "Getting Started Links";
    DocsSectionName["QUICK_LINKS"] = "Quick Links";
    DocsSectionName["WELCOME_LINKS"] = "Welcome Links";
})(DocsSectionName = exports.DocsSectionName || (exports.DocsSectionName = {}));
var DocsProtocolVersion;
(function (DocsProtocolVersion) {
    DocsProtocolVersion["V1"] = "V1";
    DocsProtocolVersion["V2"] = "V2";
    DocsProtocolVersion["V3"] = "V3";
})(DocsProtocolVersion = exports.DocsProtocolVersion || (exports.DocsProtocolVersion = {}));
/**
 * Known element names for analytics purposes.
 * Use to identify low-level components given a TraceContext
 */
var DocsHomepageElementName;
(function (DocsHomepageElementName) {
    DocsHomepageElementName["BUILD_ORACLE"] = "Build Oracle";
    DocsHomepageElementName["DISCORD"] = "Discord";
    DocsHomepageElementName["EMBED_SWAP_WIDGET"] = "Embed Swap Widget";
    DocsHomepageElementName["FORUM"] = "Forum";
    DocsHomepageElementName["GITHUB"] = "Github";
    DocsHomepageElementName["GRANTS"] = "Grants";
    DocsHomepageElementName["IMPLEMENT_SWAP"] = "Implement Swap";
    DocsHomepageElementName["PROVIDE_LIQUIDITY"] = "Provide Liquidity";
    DocsHomepageElementName["SDK"] = "SDK";
    DocsHomepageElementName["SDK_QUICK_START"] = "Sdk Quick Start";
    DocsHomepageElementName["SMART_CONTRACTS"] = "Smart Contracts";
    DocsHomepageElementName["SMART_CONTRACT_OVERVIEW"] = "Smart Contract Overview";
    DocsHomepageElementName["V3_CONTRACT_ADDRESS"] = "V3 Contract Address";
    DocsHomepageElementName["V3_CORE"] = "V3 Core";
    DocsHomepageElementName["V3_PERIPHERY"] = "V3 Periphery";
    DocsHomepageElementName["V3_SDK"] = "V3 SDK";
    DocsHomepageElementName["V3_WIDGETS"] = "V3 Widgets";
    DocsHomepageElementName["WHAT_IS_UNISWAP"] = "What is Uniswap";
    DocsHomepageElementName["WHITEPAPER"] = "Whitepaper";
    DocsHomepageElementName["WIDGETS"] = "Widgets";
})(DocsHomepageElementName = exports.DocsHomepageElementName || (exports.DocsHomepageElementName = {}));
